const CRUDVerbs = {
  CREATE: 'CREATE',
  READ: 'READ',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
};

const ACTION_TYPE_BASE = '@@reduxReactor';

export { CRUDVerbs, ACTION_TYPE_BASE };
